import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { Container, Row, Col, Card, IconButton } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { ChevronRight } from 'wix-ui-icons-common';
import { PageRoute } from '@src/types';
import { NavigationContext } from '@src/context/navigation-store/navigation-store';
import { DrillInSection } from '@src/components/drill-in-section/drill-in-section';
import { isAppEnabled } from '@src/context/selectors/ui-settings';
import { TextAndDisplayCard } from '@src/components/banner-settings/cards/text-and-display/text-and-display';
import { AppContext } from '@src/context/store';

const AdvancedOptionsCardComponent = ({ t }: InjectedTranslateProps) => {
  const { navigateToRoute } = React.useContext(NavigationContext);
  const state = React.useContext(AppContext);

  const onDrillIn = () => navigateToRoute(PageRoute.ADVANCED_OPTIONS);

  return (
    <DrillInSection
      dataHook={DataHooks.AdvancedCardContainer}
      title={t('advanced-options.card.title')}
      subtitle={t('advanced-options.card.subtitle')}
      onDrillIn={onDrillIn}
      disabled={!isAppEnabled(state)}
    />
  );
};

export const AdvancedOptionsCard = translate()(AdvancedOptionsCardComponent);
